import { render } from "./AMENDMENT.vue?vue&type=template&id=6ce2f411&scoped=true"
import script from "./AMENDMENT.vue?vue&type=script&lang=js"
export * from "./AMENDMENT.vue?vue&type=script&lang=js"

import "./AMENDMENT.vue?vue&type=style&index=0&id=6ce2f411&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ce2f411"]])

export default __exports__